export default "__VITE_ASSET__CehWtsHH__"